import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Legend, Tooltip } from 'recharts';

interface SpiderChartProps {
  data: Array<{
    metric: string;
    baseline: number;
    current: number;
    target: number;
    fullMark: number;
  }>;
  title?: string;
  color?: string;
}

export default function SpiderChart({ data, title, color = '#00d9ff' }: SpiderChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-cyber-text-muted">
        No metric data available
      </div>
    );
  }

  return (
    <div className="w-full">
      {title && (
        <h3 className="text-lg font-display font-bold text-cyber-text-primary mb-4">
          {title}
        </h3>
      )}
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={data}>
          <PolarGrid stroke="#2a2a4a" />
          <PolarAngleAxis
            dataKey="metric"
            tick={{ fill: '#8b9dc3', fontSize: 12 }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={{ fill: '#8b9dc3', fontSize: 10 }}
          />
          {/* Baseline (Starting Point - 0) */}
          <Radar
            name="Baseline"
            dataKey="baseline"
            stroke="#4a4a6a"
            fill="#4a4a6a"
            fillOpacity={0.1}
            strokeWidth={1}
            strokeDasharray="5 5"
          />
          {/* Target (Goal - 100%) */}
          <Radar
            name="Target"
            dataKey="target"
            stroke="#00ff88"
            fill="#00ff88"
            fillOpacity={0.1}
            strokeWidth={2}
            strokeDasharray="3 3"
          />
          {/* Current Progress */}
          <Radar
            name="Current Progress"
            dataKey="current"
            stroke={color}
            fill={color}
            fillOpacity={0.4}
            strokeWidth={3}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#0a0a1a',
              border: `1px solid ${color}`,
              borderRadius: '8px',
              color: '#dfe6e9',
            }}
            formatter={(value: number, name: string) => {
              const label = name === 'current' ? 'Current Progress' : name === 'target' ? 'Target' : 'Baseline';
              return [`${value.toFixed(1)}%`, label];
            }}
          />
          <Legend
            wrapperStyle={{ color: '#dfe6e9', fontSize: '12px' }}
            iconType="circle"
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
